import _extends from 'babel-runtime/helpers/extends';
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import classNames from 'classnames';
export default (function (props) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
    className = props.className,
    avatar = props.avatar,
    title = props.title,
    description = props.description,
    others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
  var classString = classNames(prefixCls + '-meta', className);
  var avatarDom = avatar ? React.createElement('div', {
    className: prefixCls + '-meta-avatar'
  }, avatar) : null;
  var titleDom = title ? React.createElement('div', {
    className: prefixCls + '-meta-title'
  }, title) : null;
  var descriptionDom = description ? React.createElement('div', {
    className: prefixCls + '-meta-description'
  }, description) : null;
  var MetaDetail = titleDom || descriptionDom ? React.createElement('div', {
    className: prefixCls + '-meta-detail'
  }, titleDom, descriptionDom) : null;
  return React.createElement('div', _extends({}, others, {
    className: classString
  }), avatarDom, MetaDetail);
});